import React from 'react';
import { Icon } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
import { AnalyticsHelpers } from '../../analytics.helpers';
import { theme } from '../../../../global/theme';
import './share-block.scss';
export const ShareBlock = ({ onClick, user }) => {
    const cn = AnalyticsHelpers.makeAnalyticsClass('share');
    const getRole = (user) => {
        return user.institutionsMemberships.find(element => {
            return element.userId === user.id;
        }).role;
    };
    const hyperlinkFromPlans = (user) => {
        let hyperlink = 'https://doxyme.typeform.com/to/tvBuY5PA#plan=';
        switch (user.subscriptionType) {
            case 'free': {
                return hyperlink + 'free';
                break;
            }
            case 'pro': {
                return hyperlink + 'professional';
                break;
            }
            case 'clinic': {
                switch (getRole(user)) {
                    case 'member': {
                        return hyperlink + 'member';
                        break;
                    }
                    case 'admin': {
                        return hyperlink + 'admin';
                        break;
                    }
                    case 'owner': {
                        return hyperlink + 'owner';
                        break;
                    }
                    default:
                        return hyperlink + 'free';
                }
                break;
            }
            default:
                return hyperlink + 'free';
        }
    };
    return (<div className={cn('wrapper')} style={{ color: theme.Colors.black }}>
      <Icon className={cn('icon')} name="idea" size="x-large"/>
      <div className={cn('title')}>
        <FormattedMessage id="account.analytics.usage.share-block.question"/>
      </div>
      <a className={cn('link')} href={hyperlinkFromPlans(user)} target="_blank" onClick={onClick} rel="noreferrer">
        <FormattedMessage id="account.analytics.usage.share-block.link"/>
      </a>
    </div>);
};
